import { Table } from 'baseui/table'
import PaginationControls from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/PaginationControls'
import BackToSearchButton from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/BackToSearchButton'
import { SearchModalBody, SearchModalFooter } from './styled-components'
import useMeterSearchStyles from './useMeterSearchStyles'

const SearchResultsTable = ({
  columns,
  data,
  currentPage,
  totalPages,
  onPageChange,
  onBackToSearch,
  backButtonText,
  t,
  translationPrefix
}) => {
  const { isPulse, tableOverrides } = useMeterSearchStyles()

  return (
    <>
      <SearchModalBody $pulse={isPulse}>
        <Table columns={columns} data={data} overrides={tableOverrides} />

        <PaginationControls
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          t={t}
          translationPrefix={translationPrefix}
        />
      </SearchModalBody>

      <SearchModalFooter $pulse={isPulse} $alignStart>
        <BackToSearchButton onClick={onBackToSearch} text={backButtonText} />
      </SearchModalFooter>
    </>
  )
}

export default SearchResultsTable
